import { getDecoratorType } from '@tencent/workbench-core';
import { ControllerRegistry } from '../../registries/controller-registry.js';
import { ActionPointRegistry } from '../../registries/action-point-registry.js';

/**
 * Use 装饰器，可以为 ActionPoint 或 Controller 添加一个中间件
 *
 * @decorator
 * @public
 */
// eslint-disable-next-line @typescript-eslint/no-unsafe-function-type
function Use(...args) {
    return function (target, targetKey, descriptor) {
        if (getDecoratorType([target, targetKey, descriptor]) === 'method') {
            ActionPointRegistry.use(target, targetKey, args);
            return descriptor;
        }
        ControllerRegistry.merge(target, {
            middlewares: {
                use: args,
            },
        });
    };
}

export { Use };
//# sourceMappingURL=use.js.map
